import useCols from './useCols';
import useRows from './useRows';

const useTableData = ({ releases, withIncidentsCount }) => {
  const cols = useCols({ releases, withIncidentsCount });
  const rows = useRows({ releases, withIncidentsCount });

  return {
    cols,
    rows
  };
};

export default useTableData;
